import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { selectCoreState } from '@app/core/store/core.selectors';
import { Store } from '@ngrx/store';
import { filter, tap } from 'rxjs';

@Component({
  selector: 'app-location-template-modal',
  templateUrl: './location-template-modal.component.html',
  styleUrls: ['./location-template-modal.component.scss']
})
export class LocationTemplateModalComponent implements OnInit {
  selectAll: boolean = false;
  selectedLocation: number | null = null;
  locationList: { value: number, label: string }[] = [];
  isValidSelection: boolean = false;
  user;
  show_location: boolean;

  selectedItems: { [key: string]: boolean } = {
    ProductStorageLocations: false,
    ProductCategories: false,
    ProductCountMethods: false,
    ProductBarcodes: false
  };

  private translationKeys = {
    'ProductStorageLocations': 'storages',
    'ProductCategories': 'categories',
    'ProductCountMethods': 'countTypeMethods',
    'ProductBarcodes': 'barcodes'
  };

  constructor(
    private store$: Store<Store>,
    public dialogRef: MatDialogRef<LocationTemplateModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    
    if (this.data) {

      if (this.data.location) {
          this.selectedLocation = this.data.location.value;

          const exists = this.locationList.some(loc => loc.value === this.selectedLocation);
          if (!exists) {
              this.locationList.push(this.data.location);
          }
      }

      if (this.data.options) {
          Object.keys(this.selectedItems).forEach(key => {
              this.selectedItems[key] = this.data.options.includes(this.translationKeys[key]);
          });
      }
  }

  this.store$
      .select(selectCoreState)
      .pipe(
          filter(res => !!res),
          tap((res) => {
              this.user = res.me;
              this.show_location = res.show_location;

              if (res.me?.locName) {
                  const locID = parseInt(res.me?.locID, 10);
                  
                  if (!this.selectedLocation) {
                      this.selectedLocation = locID;
                  }

                  this.addUniqueLocation({ value: locID, label: res.me.locName });
              }

              if (this.user?.usrLocations) {
                  Object.entries(this.user.usrLocations).forEach(([locID, locName]) => {
                      this.locationList.push({ value: Number(locID), label: String(locName) });
                  });
              }
              
              this.locationList = Array.from(new Map(this.locationList.map(item => [item.value, item])).values());
              this.validateSelection();
          })
      )
      .subscribe();
  }

  toggleAll(): void {
    Object.keys(this.selectedItems).forEach(key => {
      this.selectedItems[key] = this.selectAll;
    });
    this.validateSelection();
  }

  validateSelection(): void {
    const isAnyCheckboxSelected = Object.values(this.selectedItems).some(value => value);
    this.isValidSelection = isAnyCheckboxSelected && this.selectedLocation !== null;
  }

  saveSelection(): void {
    if (this.isValidSelection) {
      const translatedItems = Object.keys(this.selectedItems).reduce((acc, key) => {
          const translatedKey = this.translationKeys[key] || key;  
          acc[translatedKey] = this.selectedItems[key];
          return acc;
      }, {});

      this.dialogRef.close({
          location: this.locationList.find(loc => loc.value === this.selectedLocation),
          options: translatedItems  
      });
    }
  }

  addUniqueLocation(location: { value: number, label: string }) {
    const exists = this.locationList.some(loc => loc.value === location.value);
    if (!exists) {
        this.locationList.push(location);
    }
  }


}
